import { MultiTierTax } from './../../classes/multiTierTax/multiTierTax';
import { rates } from './config';
import { ZorgVerzekeringsWetConfig } from './interface';

export class ZorgVerzekeringsWet {
    
    tax: number;
    
    constructor(data: ZorgVerzekeringsWetConfig) {
        const property = data.employed ? 'employed' : 'notEmployed';
        
        this.tax = new MultiTierTax(rates[property][data.year], data.income).tax;
    }
    
}
